import operations from 'rlink-collections/operations';
import RequestReference from 'rlink-data-connector/storage/RequestReference';
import {count} from 'rlink-data-connector/storage/collections';

export default function _updateReferenceValues (innerReference, referenceValue, {addToPath, ...meta}, updatedReferences) {
  let updateOps = [];
  if (addToPath) {
    updateOps.push([
      innerReference.storagePath('reference', ...addToPath),
      operations.add,
      referenceValue,
    ]);
  } else {
    updateOps.push([
      innerReference.storagePath('reference'),
      operations.set,
      referenceValue,
    ]);
  }
  updateOps.push([
    innerReference.storagePath('timestamp'),
    operations.set,
    new Date(),
  ]);
  if (meta && count(meta) > 0) {
    let {hasData, ...remainingMeta} = meta;
    if (hasData !== false) {
      updateOps.push([
        innerReference.storagePath('hasData'),
        operations.set,
        true,
      ]);
    }
    updateOps.push([
      innerReference.storagePath('meta'),
      operations.set,
      remainingMeta,
    ]);
  }
  if (innerReference instanceof RequestReference) {
    updateOps.push([
      innerReference.storagePath('pending'),
      operations.set,
      false,
    ]);
    updateOps.push([
      innerReference.storagePath('error'),
      operations.set,
      false,
    ]);
  }

  updatedReferences[innerReference] = innerReference;
  return updateOps;
}



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/storage/_updateReferenceValues.js